/**
 * Cum se numesc, în română, valorile care vin de la server.
 *
 * Statusurile, prioritățile și categoriile unui tichet sunt **date**: le
 * cunoaște API-ul, le filtrează backendul, le folosește botul în
 * `AGENT_FEEDBACK_TRANSITIONS`, și sunt scrise așa în cele 68 de tichete
 * existente. Redenumirea lor ar rupe contractul cu agentul și istoricul.
 *
 * Deci traducerea e **doar afișare**: un tabel într-un singur loc, de la valoare
 * la eticheta pe care o citește un om. Valoarea circulă neatinsă; eticheta nu
 * pleacă niciodată către server.
 *
 * O valoare fără traducere se afișează ca atare, nu ca gol: un status nou
 * adăugat în backend trebuie să se vadă, chiar și în engleză, până i se scrie
 * rândul aici — o etichetă goală ar ascunde tichetul.
 */

export const STATUS_LABELS = {
  "Open": "Deschis",
  "In Progress": "În lucru",
  "Responded": "Răspuns",
  "Fix Deployed": "Reparație livrată",
  "Resolved": "Rezolvat",
  "Closed": "Închis",
  "Reopened": "Redeschis",
  "Awaiting Confirmation": "Așteaptă confirmarea",
};

export const PRIORITY_LABELS = {
  Low: "Scăzută",
  Medium: "Medie",
  High: "Ridicată",
  Critical: "Critică",
};

export const CATEGORY_LABELS = {
  "Bug": "Defect",
  "Feature Request": "Cerere de funcționalitate",
  "Crash": "Cădere",
  "UI Issue": "Problemă de interfață",
};

/** Rezultatele pe care le raportează agentul, tot valori de server. */
export const AGENT_OUTCOME_LABELS = {
  "Fix Deployed": "Reparație livrată",
  "Partial Fix": "Reparație parțială",
  "Needs Review": "Are nevoie de verificare",
  "Cannot Fix": "Nu poate fi reparat",
  fix_deployed: "Reparație livrată",
  partial_fix: "Reparație parțială",
  needs_review: "Are nevoie de verificare",
  cannot_fix: "Nu poate fi reparat",
};

const table = (map) => (value) => (value == null || value === "" ? "" : (map[value] ?? String(value)));

export const statusLabel = table(STATUS_LABELS);
export const priorityLabel = table(PRIORITY_LABELS);
export const categoryLabel = table(CATEGORY_LABELS);
export const agentOutcomeLabel = table(AGENT_OUTCOME_LABELS);

/** „Toate", pentru filtrele care au o opțiune fără valoare. */
// Rolurile: valorile („owner", „admin", „member", „guest") sunt ale serverului
// și se trimit ca atare; se traduc TOATE etichetele, nu jumătate. „Oaspete", nu
// „Invitat", ca să nu se încurce cu invitațiile din ecranul de alături.
export const ROLE_LABELS = {
  owner: "Proprietar", admin: "Administrator", member: "Membru", guest: "Oaspete",
};
export const ROLES = ["owner", "admin", "member", "guest"];
export const roleLabel = table(ROLE_LABELS);

// Filtrele rapide sunt și stare internă: valoarea rămâne cea comparată în cod.
export const QUICK_FILTER_LABELS = {
  // „Active" era și cheie, și etichetă — același șir în două roluri. Nu strica
  // nimic, dar făcea imposibil de spus dintr-o privire care e care, iar
  // paznicul din comparisonKeys.test.js nu le putea deosebi nici el.
  "All": "Toate", "Active": "Doar active", "My work": "Ale mele",
  "Needs my confirmation": "Așteaptă confirmarea mea",
  "Recently deployed": "Livrate recent",
};
export const quickLabel = table(QUICK_FILTER_LABELS);

// O aplicație pe care un tichet vechi o poartă, dar care nu mai e în registru.
// Se arată ca atare, marcată — aceeași regulă ca la o stare necunoscută: nu se
// pierde, nu se rescrie tăcut.
export const OUT_OF_LIST = "nu mai e în listă";
export const appLabel = (value, known) =>
  (value == null || value === "" ? "" : known ? String(value) : `${value} (${OUT_OF_LIST})`);

export const ALL = "All";
export const ALL_LABEL = "Toate";

/** Eticheta unui filtru: „Toate" pentru sentinel, traducerea pentru restul. */
export const filterLabel = (value, translate) =>
  (value === ALL ? ALL_LABEL : translate(value));
